import { render, staticRenderFns } from "./two-factor-authorization.vue?vue&type=template&id=7c43051a&"
import script from "./two-factor-authorization.vue?vue&type=script&lang=js&"
export * from "./two-factor-authorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports